"use strict";
/**
 * @copyright 2020 Microsoft Corporation
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Control that tracks the help context based on the active primary form.
         * @internal
         */
        var HelpContextTracker = /** @class */ (function (_super) {
            __extends(HelpContextTracker, _super);
            function HelpContextTracker(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.notifyPending = false;
                _this.usingDisposable($dyn.observe(_this.getActiveFormName, function (activeFormName) { return _this.isNotifyPending(activeFormName); }));
                $dyn.ax.helpPane.refreshHelp = function () {
                    // Invoke the command with the most up-to-date active form name we have
                    var activeForm = $dyn.shell.getActiveForm();
                    if (activeForm) {
                        $dyn.callFunction(_this.RefreshHelp, _this, [$dyn.context(activeForm).FormName]);
                    }
                    else {
                        $dyn.callFunction(_this.RefreshHelp, _this, [_this.formName]);
                    }
                };
                return _this;
            }
            /**
             * Retrieve active form name
             * @returns Name of active form
             */
            HelpContextTracker.prototype.getActiveFormName = function () {
                // Do not track form context change unless the help pane or the app designer pane are the active form on the aside pane
                // This optimizes the cases when help/designer pane is not visible
                if (($dyn.ax.helpPane.pane && $dyn.shell.getActiveAsideForm() === $dyn.ax.helpPane.pane.targetElement) ||
                    ($dyn.ax.appDesigner.pane && $dyn.shell.getActiveAsideForm() === $dyn.ax.appDesigner.pane.targetElement) ||
                    ($dyn.ax.taskRecording.pane && $dyn.shell.getActiveAsideForm() === $dyn.ax.taskRecording.pane.targetElement)) {
                    // In order to update the help pane while open and switching forms, we need to retrieve the active form
                    // from the $dyn.activeForm observable where $dyn.value adds $dyn.activeForm to the computed scope.
                    var activeForm_1 = $dyn.value($dyn.activeForm);
                    if (activeForm_1) {
                        var formContext = $dyn.context(activeForm_1);
                        if (formContext) {
                            return $dyn.value(formContext.FormName);
                        }
                    }
                }
            };
            /**
             * Determine if client is busy and notification is still pending
             * @param activeFormName Active form name
             */
            HelpContextTracker.prototype.isNotifyPending = function (activeFormName) {
                var _this = this;
                if (activeFormName && this.ContextChanged) {
                    this.formName = activeFormName;
                    if (!this.notifyPending) {
                        this.notifyPending = true;
                        // Wait till client is not busy - this will unblock the interaction channel
                        $dyn.observe($dyn.clientBusy, function (isBusy) {
                            if (isBusy === false) {
                                if (_this.notifyPending) {
                                    var args = ($dyn.shell && $dyn.shell.ProductId) ? [_this.formName, $dyn.shell.ProductId] : [_this.formName];
                                    $dyn.callFunction(_this.ContextChanged, _this, args);
                                    _this.notifyPending = false;
                                }
                                // No need to observe clientBusy anymore until the form context changes again
                                return false;
                            }
                        });
                    }
                }
            };
            return HelpContextTracker;
        }($dyn.ui.Control));
        controls.HelpContextTracker = HelpContextTracker;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=HelpContextTracker.js.map
